import { TextInput as VFTextInput } from "@vfuk/core-text-input/dist/TextInput";
import { TextInputProps as VFTextInputProps } from "@vfuk/core-text-input/dist/TextInput.types";
import { ReactNode, RefObject, forwardRef, useState } from "react";
import FloatingLabelBase from "../FloatingLabelBase/FloatingLabelBase";
import { Subtext } from "../Subtext";

type TextInputProps = {
  label: string;
  error?: string;
  tooltipError?: ReactNode;
  spaceForError?: boolean;
  fieldHeightSmall?: boolean;
  readonly?: boolean;
  tabindex?: string;
  subtext?: string;
  hideEyeSymbol?: boolean;
} & VFTextInputProps;

export const FloatingLabelInput = forwardRef<VFTextInput, TextInputProps>(
  ({ label, error, subtext, ...inputProps }: TextInputProps, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <>
        <FloatingLabelBase
          forceFloat={!!inputProps.value}
          onShowPassword={() => setShowPassword(!showPassword)}
          showPassword={showPassword}
          label={label}
          error={error}
          {...inputProps}
        >
          <VFTextInput
            domRef={ref as RefObject<HTMLInputElement>}
            {...inputProps}
            placeholder=""
            type={showPassword ? "text" : inputProps.type}
          />
        </FloatingLabelBase>
        {subtext && <Subtext text={subtext} />}
      </>
    );
  }
);

FloatingLabelInput.displayName = "FloatingLabelInput";
